const scrollBufferTop = 10; //this buffer is reserving space for sticky nav-bar, adjust it base on projects

const getElementDistanceToTopDom = (element) => {
  const rect = element.getBoundingClientRect();
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  return rect.top + scrollTop; //adjust the scroll top base on sticky nav-bar
};
//please use this function to scroll to element always
// once is used when
export const scrollToElement = (element, focus = true) => {
  if (!element) return;

  requestAnimationFrame(() => {
    const offsetTop = getElementDistanceToTopDom(element);
    window.scrollTo({
      top: offsetTop - scrollBufferTop,
      behavior: "smooth",
    });

    if (focus) {
      element.focus({ preventScroll: true });
    }
  });
};

export const scrollToElementId = (elementId, focus = true) => {
  const element = document.getElementById(elementId);
  if (element) {
    console.log(elementId);
    scrollToElement(element, focus);
  }
};

/**
 * Usage：
 * waitForFullLoad().then(() => {
 *    // Your code here
 * });
 */
export const waitFullPageLoad = () => {
  // Function to ensure all elements are loaded, including sticky headers
  return new Promise((resolve) => {
    const checkReadyState = () => {
      if (document.readyState === "complete") {
        resolve();
      } else {
        setTimeout(checkReadyState, 100); // Check again after 100ms if not complete
      }
    };
    checkReadyState();
  });
};

export const scrollToHashWhenLoad = () => {
  if (window.location.hash !== "" && window.location.hash !== "#" && window.location.hash !== "#!") {
    // Disable the browser's auto-scroll restoration behavior
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    new Promise((resolve) => {
      const checkReadyState = () => {
        if (document.readyState === "complete") {
          resolve();
        } else {
          setTimeout(checkReadyState, 100); // Check again after 100ms if not complete
        }
      };
      checkReadyState();
    }).then(() => {
      scrollToElementId(window.location.hash.substring(1));
    });
  }
};
